import { isWechat } from '@weike/toolkit'

export function isInMiniProgram() {
  if (!isWechat()) {
    return false
  }
  const ua = navigator.userAgent.toLocaleLowerCase()
  return (
    /miniprogram/.test(ua) ||
    (window as any).__wxjs_environment === 'miniprogram'
  )
}
